import React, { Component } from 'react';
import TinyToothComponent from '../../commons/Charting/TinyToothComponent';

export default class Tooth extends Component {
    state = {
        toothData: null
    };

    set_col(key) {
        var col = 'col-xs-1 col-sm-1';
        if(key === 0) {
            if(this.props.toothPos === 'left') {
                let len = 10 - this.props.toothNumbers.length;

                col = col + ' col-md-offset-' + len + ' col-sm-offset-' + len + ' col-xs-offset-' + len;
            }
        }
        return col;
    }

    openModal = (e, toothNumber) => {
        if (this.props.selectedChart === null) {
            alert('Please select a chart or create a new one first');

            return false;
        }

        this.props.openModal(e, toothNumber);
    };

    render() {
        return (
            <div className="row">
                {this.props.toothNumbers.map((toothNumber, i) => {
                    return (
                        <div className={this.set_col(i)} key={i} style={{marginRight: '2px'}}>
                            <div className="row">
                                <div id={`tooth-${toothNumber}`} className="tooth_container text-center"
                                     style={{cursor: 'pointer'}}>

                                    <TinyToothComponent
                                        openModal={this.openModal}
                                        openTimelineModal={this.props.openTimelineModal}
                                        selectedChart={this.props.selectedChart}
                                        toothId={`${toothNumber}`}
                                        color='transparent'
                                        toothData={this.props.charting.data}/>
                                </div>
                                <div className="text-center">
                                    {toothNumber}
                                </div>

                                <div>&nbsp;</div>
                            </div>
                        </div>
                    )
                })}
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/charting/Tooth.js
 **/